<template>
  <div>
    <!-- 服务商 -->
    <div class="detail-wrap">
      <el-form ref="editForm" :model="tenant">
        <div class="d-header">
          <div class="fl">
            <i class="el-icon-info" />
            <!-- {{ dataId ? '查看' : '新增' }}工单 -->
            工单号：<span style="font-weight: 600;color: #2196f3;margin-right: 5px;">{{ formData.orderNo }}</span>
            <!-- 服务类型 -->
            <span class="information">{{ formData.serverTypeName }}</span>
            <!-- 工单状态 -->
            <span class="information" v-if="formData.stat==1">登记</span>
            <span class="information" v-if="formData.stat==2">发布</span>
            <span class="information" v-if="formData.stat==5">已派网点</span>
            <span class="information" v-if="formData.stat==9">已派师傅</span>
            <span class="information" v-if="formData.stat==10">师傅已接单</span>
            <span class="information" v-if="formData.stat==11">已预约</span>
            <span class="information" v-if="formData.stat==13">已出发</span>
            <span class="information" v-if="formData.stat==17">已上门</span>
            <span class="information" v-if="formData.stat==20">完工暂存</span>
            <span class="information" v-if="formData.stat==30">寄修待确认</span>
            <span class="information" v-if="formData.stat==31">待寄件</span>
            <span class="information" v-if="formData.stat==32">已寄待签收</span>
            <span class="information" v-if="formData.stat==36">待维修</span>
            <span class="information" v-if="formData.stat==37">修好待寄出</span>
            <span class="information" v-if="formData.stat==38">客户待签收</span>
            <span class="information" v-if="formData.stat==40">退换待确认</span>
            <span class="information" v-if="formData.stat==41">旧机待退回</span>
            <span class="information" v-if="formData.stat==42">旧机待签收</span>
            <span class="information" v-if="formData.stat==43">旧机已签收</span>
            <span class="information" v-if="formData.stat==44">新机待寄出</span>
            <span class="information" v-if="formData.stat==45">新机已寄出</span>
            <span class="information" v-if="formData.stat==47">新机待签收</span>
            <span class="information" v-if="formData.stat==48">新机已签收</span>
            <span class="information" v-if="formData.stat==49">退换被驳回</span>
            <span class="information" v-if="formData.stat==61">已完工</span>
            <span class="information" v-if="formData.stat==62">网点确认完工</span>
            <span class="information" v-if="formData.stat==63">中心完工审核</span>
            <span class="information" v-if="formData.stat==64">总部完工审核</span>
            <span class="information" v-if="formData.stat==91">待结算</span>
            <span class="information" v-if="formData.stat==92">结算驳回</span>
            <span class="information" v-if="formData.stat==93">结算中止</span>
            <span class="information" v-if="formData.stat==94">已结算</span>
            <span class="information" v-if="formData.stat==97">申请关闭</span>
            <span class="information" v-if="formData.stat==98">挂起</span>
            <span class="information" v-if="formData.stat==99">取消</span>
            <span class="information" v-else></span>


            <!-- 紧急度 -->
            <span class="information" v-if="formData.urger==0">一般</span>
            <span class="information" v-else-if="formData.urger==1">紧急</span>
            <span class="information" v-else-if="formData.urger==2">特急</span>
            <span class="information" v-else>未知</span>


          </div>
          <div style="">

            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-thumb">指派中心
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-chat-line-square">
              用户催单
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-tickets">工单跟进
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-document-delete">
              关闭工单
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-document-copy">打印工单
            </el-button>


          </div>
          <!-- <div class="fr">
          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置</el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div> -->
        </div>

        <div>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="工单详情" name="first">
              <!-- 基本信息 -->
              <dix style="display: flex;  overflow: unset!important;
    overflow-y: scroll!important;
    height: 100vh!important; ">
                <div class="d-cont edit-mce-box" style="width: 80%;">
                  <div class="d-item" style="padding-top: 10px;">
                    <!-- <div class="title first"><b>受理信息</b></div> -->
                    <table class="table-detail">
                      <tbody>

                        <tr>
                          <th>姓名</th>
                          <td>{{ formData.userName }}</td>
                          <th>来电号码</th>
                          <td>{{ formData.userMobile }}</td>
                          <th>用户类型</th>
                          <td v-if="formData.userType==0">普通用户</td>
                          <td v-if="formData.userType==1">售前机</td>
                          <td v-if="formData.userType==2">工程机</td>
                          <td v-if="formData.userType==3">VIP用户</td>
                          <td v-if="formData.userType==4">经销商</td>

                          <th>生成方式</th>
                          <td>{{ formData.outOrderNo }}</td>

                        </tr>
                        <tr>
                          <th>用户单位</th>
                          <td>{{ formData.outOrderNo }}</td>
                          <th>合同号</th>
                          <td>{{ formData.outOrderNo }}</td>
                        </tr>
                        <tr style="position: relative;height: 25px;">
                          <th>用户地址</th>
                          <td style="width: 20vw!important;white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;position: absolute;top: 6px;">
                            {{ formData.userProvice }}{{ formData.userCity }}{{
                              formData.userCounty
                            }}{{ formData.userTown }}{{ formData.userAddress }}
                          </td>
                        </tr>
                        <tr>
                          <th>
                            服务类型
                          </th>
                          <td>
                            {{ formData.serverTypeName }}
                          </td>
                          <th>保修类型</th>
                          <td v-if="formData.guaranteeType==1"><span class="btn_t">保内</span></td>
                          <td v-if="formData.guaranteeType==2"><span class="btn_f">保外</span></td>
                          <td v-if="formData.guaranteeType==3"><span class="btn_f">未知</span></td>

                          <th>工单来源</th>
                          <td>{{ formData.orderTypeName }}</td>
                          <th>客诉类型</th>
                          <td>{{ formData.complaintTypeName }}</td>
                        </tr>
                        <tr>
                          <th>录单故障</th>
                          <td>{{ formData.issueFaultName }}</td>
                          <th>外部订单号</th>
                          <td>{{ formData.outOrderNo }}</td>
                          <th>购买时间</th>
                          <td>{{ formData.buyDate }}</td>
                          <th>购买商场</th>
                          <td>{{ formData.buyShop }}</td>
                        </tr>
                        <tr>
                          <th>工单标签</th>
                          <td>{{ formData.dispatchStat }}</td>

                          <th>配件状态</th>
                          <td v-if="formData.partsStat==0"><span class="btn_t">无配件</span></td>
                          <td v-if="formData.partsStat==1"><span class="btn_t">申请</span></td>
                          <td v-if="formData.partsStat==2"><span class="btn_t">审核</span></td>
                          <td v-if="formData.partsStat==3"><span class="btn_t">出库</span></td>
                          <td v-if="formData.partsStat==4"><span class="btn_t">网点收货</span></td>
                          <td v-if="formData.partsStat==8"><span class="btn_f">驳回</span></td>
                          <td v-if="formData.partsStat==9"><span class="btn_f">取消</span></td>
                          <td v-if="formData.partsStat==11"><span class="btn_t">更换</span></td>
                          <td v-if="formData.partsStat==12"><span class="btn_t">网点返厂</span></td>
                          <td v-if="formData.partsStat==13"><span class="btn_t">返厂确认</span></td>
                          <th>回访状态</th>
                          <td v-if="formData.recallStat==0"><span class="btn_f">未回访</span></td>
                          <td v-if="formData.recallStat==1"><span class="btn_t">已抽样</span></td>
                          <td v-if="formData.recallStat==2"><span class="btn_t">已回访</span></td>
                          <td v-if="formData.recallStat==5"><span class="btn_t">用户已评价</span></td>


                          <th>申诉状态</th>
                          <td v-if="formData.siteComplainStat==0"><span class="btn_t">无申诉</span></td>
                          <td v-if="formData.siteComplainStat==3"><span class="btn_t">待申诉</span></td>
                          <td v-if="formData.siteComplainStat==5"><span class="btn_t">已申诉</span></td>
                          <td v-if="formData.siteComplainStat==7"><span class="btn_t">中心已审核</span></td>
                          <td v-if="formData.siteComplainStat==8"><span class="btn_f">中心驳回</span></td>
                          <td v-if="formData.siteComplainStat==9"><span class="btn_t">总部已处理</span></td>
                          <td v-if="formData.siteComplainStat==99"><span class="btn_f">取消</span></td>
                        </tr>
                        <!-- <tr>

                          <th>发票号</th>
                          <td>{{ formData.invoiceNo }}</td>

                          <th>报单条码</th>
                          <td>{{ formData.brarcode }}</td>
                          <th>质检状态</th>
                          <td v-if="formData.qualityStat==0"><span class="btn_f">未质检</span></td>
                          <td v-if="formData.qualityStat==1"><span class="btn_f">质检通过</span></td>
                          <td v-if="formData.qualityStat==2"><span class="btn_f">质检不通过</span></td>
                        </tr> -->



                        <tr style="position:relative;height:25px;">


                          <th>述求</th>
                          <td style="width: 20vw!important;white-space: nowrap;position: absolute;
    overflow: hidden;
    text-overflow: ellipsis;">{{ formData.appeals }}</td>
                        </tr>

                        <tr>

                        </tr>


                      </tbody>
                    </table>
                  </div>
                  <div class="d-item" style="padding-top: 10px;">
                    <!-- <div class="title first"><b>受理信息</b></div> -->
                    <table class="table-detail">
                      <tbody>

                        <tr>
                          <th>机构名称</th>
                          <td>{{ formData.orgName }}</td>
                          <th>网点名称</th>
                          <td>{{ formData.siteName }}</td>
                          <th>工程师名称</th>
                          <td>{{ formData.engineerName }}</td>
                          <th>督办人</th>
                          <td>{{ formData.engineerName }}</td>

                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!-- 集合 -->

                  <div class="d-item" style="margin-top: 10px;">
                    <table class="table-detail" style="width: 100%;">
                      <tbody style="width: 100%;">
                        <template>
                          <el-tabs v-model="activeName2" style="width: 100%;" class="gather">
                            <el-tab-pane label="节点图" name="first">
                              <div style="margin-top: 10px;">
                                <el-steps :active="2" align-center finish-status="success">
                                  <el-step title="客户预约" description="2022-10-12 12:00"></el-step>
                                  <el-step title="出发签到" description="2022-10-12 12:00"></el-step>
                                  <el-step title="现场签到" description="2022-10-12 12:00"></el-step>
                                  <el-step title="屏体检查" description="2022-10-12 12:00"></el-step>
                                  <el-step title="关单评价" description="2022-10-12 12:00"></el-step>
                                  <el-step title="现场签到" description="2022-10-12 12:00"></el-step>
                                  <el-step title="屏体检查" description="2022-10-12 12:00"></el-step>
                                  <el-step title="关单评价" description="2022-10-12 12:00"></el-step>

                                </el-steps>
                              </div>
                            </el-tab-pane>
                            <el-tab-pane label="节点信息" name="second">
                              <tr>
                                <th>派中心时间</th>
                                <td>{{ formData.soOrderProcessDTO.takeOrgTime }}</td>

                                <th>派单时间</th>
                                <td>{{ formData.soOrderProcessDTO.takeTime }}</td>

                                <th>网点确认接单时间</th>
                                <td>{{ formData.soOrderProcessDTO.acceptOperateTime }}</td>

                                <th>派工程师时间</th>
                                <td>{{ formData.soOrderProcessDTO.takeEngineerTime }}</td>
                              </tr>
                              <tr>
                                <th>
                                  工程师确认接单时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.engineerAcceptOperateTime }}
                                </td>
                                <th>
                                  首次预约操作时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.firstBookOperateTime }}
                                </td>
                                <th>
                                  首次预约时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.firstBookDate }}
                                </td>
                                <th>
                                  预约操作时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.bookOperateTime }}
                                </td>
                              </tr>
                              <tr>
                                <th>
                                  预约时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.bookDate }}
                                </td>
                                <th>
                                  出发时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.startOffTime }}
                                </td>
                                <th>
                                  上门签到时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.onDoorTime }}
                                </td>
                                <th>
                                  上门签到地址
                                </th>
                                <td colspan="">
                                  {{ formData.soOrderProcessDTO.onDoorLocation }}
                                </td>
                              </tr>
                              <tr>
                                <th>
                                  首次完工时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.firstCompleteTime }}
                                </td>
                                <th>
                                  完工时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.completeTime }}
                                </td>
                                <th>
                                  完工地址
                                </th>
                                <td colspan="">
                                  {{ formData.soOrderProcessDTO.onTimeLocation }}
                                </td>
                                <th>
                                  网点确认完工时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.siteComplaintProcessDate }}
                                </td>
                              </tr>
                              <tr>
                                <th>
                                  中心确认完工时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.orgComfirmTime }}
                                </td>
                                <th>
                                  总部确认完工时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.officeComfirmTime }}
                                </td>
                                <th>
                                  回访时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.recallTime }}
                                </td>
                                <th>
                                  客诉跟进次数
                                </th>
                                <td colspan="">
                                  {{ formData.soOrderProcessDTO.complaintProcessTimes }}
                                </td>
                              </tr>
                              <tr>
                                <th>
                                  客诉跟进人
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.complaintProcesser }}
                                </td>
                                <th>
                                  客诉跟进时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.complaintProcessDate }}
                                </td>
                                <th>
                                  网点客诉跟进时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.siteComplaintProcessDate }}
                                </td>
                                <th>
                                  进入结算池时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.applyPayDate }}
                                </td>
                              </tr>
                              <tr>
                                <th>
                                  提交结算时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.payDate }}
                                </td>
                                <th>
                                  取消/退单时间
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.cancleDate }}
                                </td>
                                <th>
                                  取消/退单原因
                                </th>
                                <td>
                                  <!--                            <el-input type="text" autocomplete="off" v-model="tenant.orgName" clearable/>-->
                                </td>
                                <th>
                                  完工备注
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.finishNote }}
                                </td>
                              </tr>
                              <tr>
                                <th>
                                  完工审核备注
                                </th>
                                <td>
                                  {{ formData.soOrderProcessDTO.comfirmNote }}
                                </td>
                              </tr>
                            </el-tab-pane>
                            <el-tab-pane  label="产品信息" name="third" class="product">
                              <div class="product" style="">
                    <vxe-table ref="filterTable" :data="formData.soOrderLineDTOList" class="table_item"
                      style="margin:12px auto; width: 95%;" :stripe="true"
                      :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                      :row-config="{height: 30,isHover: true,padding: 0,}" :row-style="{ fontSize: '12px',  }"
                      show-overflow height="100" :column-config="{ resizable: true }">
                      <vxe-column type="seq" width="30">
                      </vxe-column>

                      <vxe-column field="itemCode" title="产品编码" ></vxe-column>
                      <vxe-column field="itemName" title="产品名称" />
                      <vxe-column field="bigCategoryName" title="产品大类名称" />
                      <vxe-column field="smallCategoryName" title="产品小类名称" />
                      <vxe-column field="qty" title="数量" />
                      <vxe-column field="sitePrice" title="服务费单价" />
                      <vxe-column field="siteFee" title="服务费"  />

                    </vxe-table>
                  </div>
                </el-tab-pane>
                            <el-tab-pane  label="附件信息" name="fourth" style="height: 260px;position: relative;">
                              <tr>
                    <th style="position: absolute;top: 34px;">上门签到</th>
                    <div style="display: flex;position: absolute;left:8vw;top:10px;">
                      <el-image v-if="formData.pic1" :preview-src-list="picList" :fit="fit"
                                :src="formData.pic1" :initial-index="0"></el-image>
                      <el-image v-else>
                        <div slot="error" class="image-slot">
                          <i class="el-icon-picture-outline"
                             style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                        </div>
                      </el-image>

                    </div>

                  </tr>
                  <tr>
                    <th style="position: absolute;top: 124px;">现场照片</th>
                    <div style="display: flex;position: absolute;left:8vw;top:100px;">
                      <el-image v-if="formData.pic1" :preview-src-list="picList" :fit="fit"
                                :src="formData.pic1" :initial-index="0"></el-image>
                      <el-image v-else>
                        <div slot="error" class="image-slot">
                          <i class="el-icon-picture-outline"
                             style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                        </div>
                      </el-image>

                    </div>

                  </tr>
                  <tr>
                    <th style="position: absolute;top: 214px;">修复照片</th>
                    <div style="display: flex;position: absolute;left:8vw;top:190px;">
                      <el-image v-if="formData.pic1" :preview-src-list="picList" :fit="fit"
                                :src="formData.pic1" :initial-index="0"></el-image>
                      <el-image v-else>
                        <div slot="error" class="image-slot">
                          <i class="el-icon-picture-outline"
                             style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                        </div>
                      </el-image>

                    </div>

                  </tr>
                            </el-tab-pane>
                            <el-tab-pane label="业务信息" name="five">
                              <tr>
                                <th>是否必访</th>
                                <td v-if="formData.isMustRecall==0"><span class="btn_f">否</span></td>
                                <td v-if="formData.isMustRecall==1"><span class="btn_t">是</span></td>
                                <th>是否可抽样</th>
                                <td v-if="formData.isCallRecall==0"><span class="btn_f">否</span></td>
                                <td v-if="formData.isCallRecall==1"><span class="btn_t">是</span></td>

                                <th>是否急单</th>
                                <td v-if="formData.isUrgent==0"><span class="btn_f">否</span></td>
                                <td v-if="formData.isUrgent==1"><span class="btn_t">是</span></td>

                                <th>是否重新完工</th>
                                <td v-if="formData.isReplaceFinish==0"><span class="btn_f">否</span></td>
                                <td v-if="formData.isReplaceFinish==1"><span class="btn_t">是</span></td>



                              </tr>
                              <tr>
                                <th>催单次数</th>
                                <td>{{ formData.urgeTimes }}</td>

                                <th>投诉次数</th>
                                <td>{{ formData.complainTimes }}</td>

                                <th>结算单</th>
                                <td>
                                  {{ formData.settleName }}
                                </td>
                                <th>
                                  sendPay打标标识
                                </th>
                                <td>
                                  {{ formData.sendPay }}
                                </td>
                              </tr>
                              <tr>
                                <th>期望上门/安装时间</th>
                                <td>{{ formData.soOrderExtendDTO.wishBookDate }}</td>

                                <th>到货签收时间</th>
                                <td>{{ formData.soOrderExtendDTO.deliverTime }}</td>

                                <th>完工模式</th>
                                <td v-if="formData.soOrderExtendDTO.finishMode==1">结算密码</td>
                                <td v-if="formData.soOrderExtendDTO.finishMode==2">上传图片</td>
                                <td v-if="formData.soOrderExtendDTO.finishMode==3">图片+条码</td>
                                <td v-if="formData.soOrderExtendDTO.finishMode==9">无验证完工</td>
                                <td v-if="formData.soOrderExtendDTO.finishMode==null"></td>


                                <th>完工方式</th>
                                <td v-if="formData.soOrderExtendDTO.finishType==1">总部代完工</td>
                                <td v-if="formData.soOrderExtendDTO.finishType==2">网点PC端完工</td>
                                <td v-if="formData.soOrderExtendDTO.finishType==3">网点APP完工</td>
                                <td v-if="formData.soOrderExtendDTO.finishType==4">师傅APP完工</td>
                                <td v-if="formData.soOrderExtendDTO.finishType==5">接口完工</td>
                                <td v-if="formData.soOrderExtendDTO.finishType==9">其他</td>
                                <td v-if="formData.soOrderExtendDTO.finishType==null"></td>

                              </tr>
                              <tr>
                                <th>质检人</th>
                                <td>{{ formData.soOrderExtendDTO.qualityMan }}</td>

                                <th>质检时间</th>
                                <td>{{ formData.soOrderExtendDTO.qualityDate }}</td>

                                <th>短信满意度</th>
                                <td v-if="formData.soOrderExtendDTO.commentLevel==1">非常满意</td>
                                <td v-if="formData.soOrderExtendDTO.commentLevel==2">满意</td>
                                <td v-if="formData.soOrderExtendDTO.commentLevel==3">一般</td>
                                <td v-if="formData.soOrderExtendDTO.commentLevel==4">不满意</td>
                                <td v-if="formData.soOrderExtendDTO.commentLevel==5">非常不满意</td>
                                <td v-if="formData.soOrderExtendDTO.commentLevel==null"></td>

                                <th>是否已发送评价短信</th>
                                <td v-if="formData.soOrderExtendDTO.isSendCommentMessage==0"><span
                                    class="btn_f">否</span></td>
                                <td v-if="formData.soOrderExtendDTO.isSendCommentMessage==1"><span
                                    class="btn_t">是</span></td>
                                <td v-if="formData.soOrderExtendDTO.isSendCommentMessage==null"></td>

                              </tr>
                              <tr>
                                <th>质检备注</th>
                                <td>{{ formData.soOrderExtendDTO.qualityRemark }}</td>

                                <th>是否二次申诉</th>
                                <td v-if="formData.soOrderExtendDTO.secondSiteComplain==0"><span class="btn_f">否</span>
                                </td>
                                <td v-if="formData.soOrderExtendDTO.secondSiteComplain==1"><span class="btn_t">是</span>
                                </td>
                                <td v-if="formData.soOrderExtendDTO.secondSiteComplain==null"></td>

                                <th>是否送装同步</th>
                                <td v-if="formData.soOrderExtendDTO.isInstallSynchro==0"><span class="btn_f">否</span>
                                </td>
                                <td v-if="formData.soOrderExtendDTO.isInstallSynchro==1"><span class="btn_t">是</span>
                                </td>
                                <td v-if="formData.soOrderExtendDTO.isInstallSynchro==null"></td>

                                <th>挂起类型</th>
                                <td v-if="formData.soOrderExtendDTO.hangupType==0">总部挂起</td>
                                <td v-if="formData.soOrderExtendDTO.hangupType==1">网点挂起</td>
                                <td v-if="formData.soOrderExtendDTO.hangupType==null"></td>

                              </tr>
                              <tr>
                                <th>挂起原因</th>
                                <td>{{ formData.soOrderExtendDTO.hangupReason }}</td>
                              </tr>
                            </el-tab-pane>

                            <el-tab-pane label="用户评价" name="six">
                              <tr>
                                <th>
                                  响应速度
                                </th>
                                <td>
                                  <el-rate v-if="formData.soOrderCommentDTO.speed!=null"
                                    v-model="formData.soOrderCommentDTO.speed" disabled show-score text-color="#ff9900"
                                    score-template="{value}">
                                  </el-rate>
                                </td>
                                <th>
                                  服务效果
                                </th>
                                <td>
                                  <el-rate v-if="formData.soOrderCommentDTO.effect!=null"
                                    v-model="formData.soOrderCommentDTO.effect" disabled show-score text-color="#ff9900"
                                    score-template="{value}">
                                  </el-rate>
                                </td>
                                <th>收费评分</th>
                                <td>
                                  <el-rate v-if="formData.soOrderCommentDTO.fee!=null"
                                    v-model="formData.soOrderCommentDTO.fee" disabled show-score text-color="#ff9900"
                                    score-template="{value}">
                                  </el-rate>
                                </td>


                              </tr>
                              <tr>
                                <th>
                                  总体评价
                                </th>
                                <td v-if="formData.soOrderCommentDTO==null||formData.soOrderCommentDTO.topLevel==null">
                                </td>
                                <td v-if="formData.soOrderCommentDTO.topLevel==1">非常满意</td>
                                <td v-if="formData.soOrderCommentDTO.topLevel==2">满意</td>
                                <td v-if="formData.soOrderCommentDTO.topLevel==3">一般</td>
                                <td v-if="formData.soOrderCommentDTO.topLevel==4">不满意</td>
                                <td v-if="formData.soOrderCommentDTO.topLevel==5">非常不满意</td>

                                <th>
                                  评价来源
                                </th>
                                <td v-if="formData.soOrderCommentDTO==null||formData.soOrderCommentDTO.sources==null">
                                </td>
                                <td v-else-if="formData.soOrderCommentDTO.sources==1">电商接口</td>
                                <td v-else-if="formData.soOrderCommentDTO.sources==2">短信回复评价</td>
                                <td v-else-if="formData.soOrderCommentDTO.sources==3">用户微信评价</td>
                                <td v-else></td>

                                <th>
                                  其他评论
                                </th>
                                <td colspan="4">
                                  {{ formData.soOrderCommentDTO.other }}
                                </td>
                              </tr>
                            </el-tab-pane>
                            <el-tab-pane label="接口信息" name="seven">
                              <div class="product">
                                <vxe-table ref="filterTable" height="350" :data="formData.soOrderPreconditionResultDTOList"
                    class="table_item pic_item" style="width: 95%;" :stripe="true"
                    :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{height: 30,isHover: true,padding: 0,}" :row-style="{ fontSize: '12px',  }"
                    show-overflow :column-config="{ resizable: true }">
                    <!--                    <vxe-column type="seq" width="55" title="序号"/>-->
                    <vxe-column field="preconditionName" title="预审条件" width="" />
                    <vxe-column field="isPast" title="是否通过" width="">
                      <template #default="{row}">
                        <span v-if="row.isPast==1">是</span>
                        <span v-else>否</span>
                      </template>
                    </vxe-column>
                    <vxe-column field="afterFlow" title="流向" width="">
                      <template #default="{row}">
                        <span v-if="row.afterFlow==1">必访</span>
                        <span v-else-if="row.afterFlow==2">申诉</span>
                        <span v-else-if="row.afterFlow==3">挂起</span>
                        <span v-else-if="row.afterFlow==4">重新完工</span>
                        <span v-else-if="row.afterFlow==9">关闭</span>
                        <span v-else></span>
                      </template>
                    </vxe-column>
                  </vxe-table>

                              </div>
                            </el-tab-pane>
                          </el-tabs>
                        </template>


                      </tbody>
                    </table>
                  </div>
                  <div style="height:160px"></div>
                </div>
                <div style="width: 20%;" class="bread">
                  <div style="padding-bottom: 90px;    margin-top: 10px; margin-left: 5px;">
                    <div class="title_icon"><i class="el-icon-date"></i></div>
                    <span>工单履历</span>
                    <el-timeline class="card_bread" style="position:relative">

                      <el-timeline-item v-for="item in formData.soOrderOperationDTOList1.slice(0, 3)" placement="top">
                        <div class="title_time"><span class="span1">{{ item.title }} </span>
                          <span class="span2">{{ item.createTime }}</span>
                        </div>
                        <el-card class="card">
                          <p>{{ item.content }}</p>
                        </el-card>
                      </el-timeline-item>


                      <!--                  <el-timeline-item-->
                      <!--                    v-for="item in tenant.soOrderOperationDTOList1.slice(3, tenant.soOrderOperationDTOList1.length)"-->
                      <!--                    :timestamp="item.createTime" placement="top">-->
                      <!--                    <el-card class="card">-->
                      <!--                      <div>{{ item.title }}</div>-->
                      <!--                      <p>{{ item.content }}</p>-->
                      <!--                    </el-card>-->
                      <!--                  </el-timeline-item>-->


                    </el-timeline>

                  </div>
                </div>
              </dix>
            </el-tab-pane>
            <el-tab-pane label="服务报告" name="second">
              <div class="d-cont edit-mce-box"
                style=" overflow: unset!important;overflow-y: scroll!important;height: 100vh!important; ">
                <div class="d-item">
                  <div class="title first"><b>服务内容</b></div>
                  <table class="table-detail">
                    <tbody>
                      <tr>
                        <th>故障现象</th>
                                <td>{{ formData.sysmtomName }}</td>

                                <th>故障原因</th>
                                <td>{{ formData.reasonName }}</td>

                                <th>维修措施</th>
                                <td>{{ formData.methodName }}</td>
                                <th>申请保外转保内</th>
                                <td v-if="formData.outTransIn==0"><span class="btn_f">否</span></td>
                                <td v-if="formData.outTransIn==1"><span class="btn_t">是</span></td>
                      </tr>
                      <!-- <tr>



                        <th>
                          故障原因
                        </th>
                        <td>
                          {{ formData.reasonName }}
                        </td>

                        <th>
                          维修措施
                        </th>
                        <td>
                          {{ formData.methodName }}
                        </td>
                      </tr> -->
                      <tr>

                        <!-- <th>保修类型</th>
                        <td v-if="formData.guaranteeType==1">保内</td>
                        <td v-if="formData.guaranteeType==2">保外</td>
                        <td v-if="formData.guaranteeType==3">未知</td>


                        <th>申请保外转保内</th>
                        <td v-if="formData.outTransIn==0">否</td>
                        <td v-if="formData.outTransIn==1">是</td> -->

                        <!-- <th>
                          完工地址
                        </th>
                        <td colspan="3">
                          {{ formData.soOrderProcessDTO.onTimeLocation }}
                        </td> -->
                      </tr>
                      <tr>
                        <th>
                          完工备注
                        </th>
                        <td colspan="7">
                          {{ formData.soOrderProcessDTO.finishNote }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="d-item">
                  <div class="title first"><b>配件更换</b>
                    <!--                    <el-button type="primary" class="button-sty btn_zdy" @click="AddListRow1_2()">-->
                    <!--                      <i class="el-icon-plus"></i>-->
                    <!--                      新增-->
                    <!--                    </el-button>-->
                  </div>
                  <div>
                    <div>
                      <vxe-table ref="filterTable" :data="formData.soOrderPartsDTOList" class="table_item"
                        style="margin:1px auto; width: 94%;" :stripe="true"
                        :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                        :row-config="{height: 30,isHover: true,padding: 0,}" :row-style="{ fontSize: '12px',  }"
                        show-overflow height="100" :column-config="{ resizable: true }">
                        <vxe-column type="selection" width="55">
                        </vxe-column>

                        <vxe-column field="partsName" title="新配件名称" />
                        <vxe-column field="oldPartsName" title="旧配件名称" />
                        <vxe-column field="barcode" title="配件条码" />
                        <vxe-column field="sitePrice" title="网点价" />
                        <vxe-column field="qty" title="更换数量" />
                        <vxe-column field="amount" title="金额" />
                        <vxe-column field="returnQty" title="网点返厂数量" />
                        <vxe-column field="returnRevQty" title="返厂数量" />

                        <!-- 是否可选费用项目 -->
                        <vxe-column field="isNeedReturn" title="是否需要返厂" width="110" :formatter="formatter" />
                        <vxe-column field="isCheck" title="是否需要审核" :formatter="formatter1" />

                      </vxe-table>
                    </div>
                  </div>
                </div>
                <div class="d-item">
                  <div class="title first"><b>费用结算(服务商)</b> <span
                      class="expense">本单费用:{{ formData.soOrderSettleDTO.siteFinalAmount }}</span></div>

                  <table class="table-detail">
                    <tbody>
                      <div>
                        <tr>
                          <th>
                            服务费用
                          </th>
                          <td>
                            {{ formData.soOrderSettleDTO.siteAmount }}
                          </td>

                          <th>
                            奖罚金额
                          </th>
                          <td>
                            {{ formData.soOrderSettleDTO.rewardAmount }}
                          </td>

                          <th>远程费用</th>
                          <td>
                            {{ formData.soOrderSettleDTO.longDistanceAmount }}
                          </td>

                          <th>
                            特设费用
                          </th>
                          <td>
                            {{ formData.soOrderSpecailFeeDTO.amount }}
                            <!-- <i class="el-icon-tickets" style="margin-left:10px;color: #00c4b3;"
                              @click="show3 = !show3">详细</i> -->
                          </td>

                        </tr>
                      </div>

                      <!--                      <td>-->
                      <!--                        <el-input type="text" autocomplete="off" v-model="tenant.esiteOrderMan4" clearable/>-->
                      <!--                      </td>-->

                    </tbody>
                  </table>
                  <div>


                    <vxe-table ref="filterTable" :data="formData.soOrderLineDTOList"
                      style="margin:1px auto; width: 94%;" :stripe="true"
                      :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                      :row-config="{height: 30,isHover: true,padding: 0,}" :row-style="{ fontSize: '12px',  }"
                      show-overflow height="100" :column-config="{ resizable: true }">
                      <vxe-column type="seq" width="55">
                      </vxe-column>

                      <!-- <vxe-column field="itemCode" title="产品编码"/> -->
                      <vxe-column field="itemName" title="特设费用名称" />
                      <vxe-column field="siteFee" title="类型" width="" />
                      <vxe-column field="bigCategoryName" title="数量" />
                      <vxe-column field="smallCategoryName" title="单价" />
                      <vxe-column field="qty" title="金额" />
                      <vxe-column field="sitePrice" title="计价单位" />


                    </vxe-table>

                  </div>
                </div>
                <div class="d-item">
                  <div class="title first"><b>费用结算(用户)</b> <span
                      class="expense">付费金额:{{ formData.soOrderSettleDTO.siteFinalAmount }}</span></div>
                  <table class="table-detail">
                    <tbody>
                      <tr>

                        <th>支付方式</th>
                        <td>
                          {{ formData.soOrderSettleDTO.userPayType }}
                        </td>

                        <th>付款方名称</th>
                        <td>
                          {{ formData.soOrderSettleDTO.userPayName }}
                        </td>

                        <th>付款方帐号</th>
                        <td>
                          {{ formData.soOrderSettleDTO.userPayAccount }}
                        </td>

                        <th>支付状态</th>
                        <td v-if="formData.soOrderSettleDTO==null||formData.soOrderSettleDTO.userPayStat==null"></td>
                        <td v-if="formData.soOrderSettleDTO.userPayStat==1">未支付</td>
                        <td v-if="formData.soOrderSettleDTO.userPayStat==2">待支付</td>
                        <td v-if="formData.soOrderSettleDTO.userPayStat==5">支付成功</td>
                        <td v-if="formData.soOrderSettleDTO.userPayStat==8">支付失败</td>
                        <td v-if="formData.soOrderSettleDTO.userPayStat==9">支付关闭</td>
                        <th>支付流水</th>
                        <td>
                          {{ formData.soOrderSettleDTO.userPayNo }}
                        </td>

                      </tr>
                      <tr>

                        <th>支付时间</th>
                        <td>
                          {{ formData.soOrderSettleDTO.userPayTime }}
                        </td>

                        <th>支付备注</th>
                        <td>
                          {{ formData.soOrderSettleDTO.userPayStatMsg }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="d-item">
                  <div class="title first"><b>完工资料</b></div>
                  <table class="table-detail">
                    <tbody>
                    <tbody>
                      <div>
                        <tr>
                          <div>
                            <th>机器条码1</th>
                            <td>
                              {{ formData.soOrderResultDTO.inCode }}
                            </td>

                            <th>机器条码2</th>
                            <td>
                              {{ formData.soOrderResultDTO.outCode }}
                            </td>

                            <th>生产日期</th>
                            <td>
                              {{ formData.soOrderResultDTO.productDate }}
                            </td>

                            <th>
                              安装时间
                            </th>
                            <td>
                              {{ formData.soOrderResultDTO.installDate }}
                            </td>
                          </div>
                        </tr>
                      </div>


                      <tr>
                        <div style="" class="pic_main">
                          <div class="pic_item">
                            <span>图片1：</span>
                            <el-image v-if="formData.soOrderResultDTO.finishPic1"
                              :src="formData.soOrderResultDTO.finishPic1" :fit="fit" :preview-src-list="srcList"
                              :initial-index="0"></el-image>
                            <el-image v-else>
                              <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"
                                  style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                              </div>
                            </el-image>
                          </div>

                          <div class="pic_item">
                            <span>图片2:</span>
                            <el-image v-if="formData.soOrderResultDTO.finishPic2"
                              :src="formData.soOrderResultDTO.finishPic2" :fit="fit" :preview-src-list="srcList"
                              :initial-index="1"></el-image>
                            <el-image v-else>
                              <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"
                                  style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                              </div>
                            </el-image>
                          </div>
                          <div class="pic_item">
                            <span>图片3:</span>
                            <el-image v-if="formData.soOrderResultDTO.finishPic3"
                              :src="formData.soOrderResultDTO.finishPic3" :fit="fit" :preview-src-list="srcList"
                              :initial-index="2"></el-image>
                            <el-image v-else>
                              <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"
                                  style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                              </div>
                            </el-image>
                          </div>
                          <div class="pic_item">
                            <span>图片4:</span>
                            <el-image v-if="formData.soOrderResultDTO.finishPic4"
                              :src="formData.soOrderResultDTO.finishPic4" :fit="fit" :preview-src-list="srcList"
                              :initial-index="3"></el-image>
                            <el-image v-else>
                              <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"
                                  style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                              </div>
                            </el-image>
                          </div>
                          <div class="pic_item">
                            <span>图片5:</span>
                            <el-image v-if="formData.soOrderResultDTO.finishPic5"
                              :src="formData.soOrderResultDTO.finishPic5" :fit="fit" :preview-src-list="srcList"
                              :initial-index="4"></el-image>
                            <el-image v-else>
                              <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"
                                  style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                              </div>
                            </el-image>
                          </div>
                          <div class="pic_item">
                            <span>图片6:</span>
                            <el-image v-if="formData.soOrderResultDTO.finishPic6"
                              :src="formData.soOrderResultDTO.finishPic6" :fit="fit" :preview-src-list="srcList"
                              :initial-index="5"></el-image>
                            <el-image v-else>
                              <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"
                                  style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                              </div>
                            </el-image>
                          </div>
                          <div class="pic_item">
                            <span>图片7:</span>
                            <el-image v-if="formData.soOrderResultDTO.finishPic7"
                              :src="formData.soOrderResultDTO.finishPic7" :fit="fit" :preview-src-list="srcList"
                              :initial-index="6"></el-image>
                            <el-image v-else>
                              <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"
                                  style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                              </div>
                            </el-image>
                          </div>
                        </div>
                      </tr>
                      <div>

                      </div>
                    </tbody>
                    </tbody>
                  </table>

                </div>
                <div style="height:160px"></div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="工单申诉" name="third">
              <div class="d-cont edit-mce-box" style=" overflow: unset!important;overflow-y: scroll!important;height: 100vh!important; ">
                <div class="d-item">
                  <div class="first">
                  </div>
                  <div class="card_item">
                    <el-steps :active="2" simple>
                      <el-step title="发起申诉" icon="el-icon-edit"></el-step>
                      <el-step title="服务商申诉" icon="el-icon-edit-outline"></el-step>
                      <el-step title="服务中心审核" icon="el-icon-document"></el-step>
                      <el-step title="总部审核" icon="el-icon-document-checked"></el-step>
                    </el-steps>
                  </div>
                </div>

                <div class="d-item">
                  <div class="first">
                    <div class="undergo">
  <el-timeline>
    <el-timeline-item  placement="top" v-for="(item, index) in formData.soOrderComplainDTOList" style="position: relative;">
      <el-card >
        <div class="audit" style="margin-left: 10px;padding-top: 5px;"> <span>2018/4/12 20:46 </span>   <span style="margin: 0px 20px">岗位：{{ item.poster }}</span>   <span>创建人：{{ item.createBy }}</span></div>
        <!-- <h4>更新 Github 模板</h4> -->
        <p style="margin-left: 10px;">张先生对单号SO20230505051123214586进行了审核，并通过此单</p>
        <div class="audit" style="display: flex; margin-left: 10px;margin-bottom: 5px;">
          <span style="line-height: 63px;">图片： </span>
          <div >
                      <el-image v-if="item.fileUrl1" :preview-src-list="srcList" :fit="fit"
                                :src="item.fileUrl1" :initial-index="0"></el-image>
                      <el-image v-else>
                        <div slot="error" class="image-slot">
                          <i class="el-icon-picture-outline"
                             style="width: 60px; height: 60px;font-size: 36px;line-height: 60px;text-align: center;"></i>
                        </div>
                      </el-image>
                     </div>
                    </div>
      </el-card>
    </el-timeline-item>
  </el-timeline>
</div>
                  </div>
                </div>
                <div style="height:160px"></div>




              </div>
            </el-tab-pane>
            <el-tab-pane label="预审记录" name="fourth">
              <!-- 预审记录 -->
              <div class="d-cont edit-mce-box">
                <div class="d-item">
                  <!-- <el-button type="primary" class="button-sty btn_zdy">
                  <i class="el-icon-plus"></i>
                  新增</el-button> -->
                  <vxe-table ref="filterTable" height="350" :data="formData.soOrderPreconditionResultDTOList"
                    class="table_item pic_item" style="width: 95%;" :stripe="true"
                    :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{height: 30,isHover: true,padding: 0,}" :row-style="{ fontSize: '12px',  }"
                    show-overflow :column-config="{ resizable: true }">
                    <!--                    <vxe-column type="seq" width="55" title="序号"/>-->
                    <vxe-column field="preconditionName" title="预审条件" width="" />
                    <vxe-column field="isPast" title="是否通过" width="">
                      <template #default="{row}">
                        <span v-if="row.isPast==1">是</span>
                        <span v-else>否</span>
                      </template>
                    </vxe-column>
                    <vxe-column field="afterFlow" title="流向" width="">
                      <template #default="{row}">
                        <span v-if="row.afterFlow==1">必访</span>
                        <span v-else-if="row.afterFlow==2">申诉</span>
                        <span v-else-if="row.afterFlow==3">挂起</span>
                        <span v-else-if="row.afterFlow==4">重新完工</span>
                        <span v-else-if="row.afterFlow==9">关闭</span>
                        <span v-else></span>
                      </template>
                    </vxe-column>
                  </vxe-table>
                </div>
              </div>
            </el-tab-pane>

          </el-tabs>
        </div>


      </el-form>
      <!-- 服务区域弹窗表 -->
    </div>
    <!-- <div style="height: 100vh; width: 5px; background-color: aquamarine;"></div> -->

  </div>
</template>

<script>
  import {
    initVxeTable
  } from '@/const/crud/admin/table';
  import Tinymce from '@/components/Tinymce';
  import request from "@/router/axios";
  // import preconditionDialog from './dialog';
  // import areaDialog from './areadialog.vue';
  import store from "@/store";
  // 城市三级联动
  import {
    regionData,
    CodeToText,
    TextToCode
  } from "element-china-area-data";
  import api from "@/api/projectApi";

  const cityOptions = ['挂壁式（5100W＜Q）变频', '挂壁式（3600W＜Q≤5100W）变频', '挂壁式（Q＜3200W）', '挂壁式 3200W≤Q≤3600W 变频'];
  const cityOptions2 = ['挂壁式1变频', '挂壁式222变频', '挂壁式3', '挂壁式 4'];
  export default {
    name: 'edit',
    props: {
      _dataId: [String, Number]
    },
    components: {
      Tinymce,
    },
    data() {
      return {
        show3: false,
        node: true,
        formData: {
          orderNo: '', // 工单号,前缀"SO"+年月日+6位流水号
          createType: 0, // 生成方式：0默认;1客服;2excel;3接口;4公众号;5PC自建单;6APP自建单;7服务中心;9其它;94苏宁帮客;95京东服务市场;97天猫服务市场;98京东测量服务;99京东ue平台;100京东3C
          orderTypeId: 0, // 工单来源ID,关联bas_order_type.id
          serverTypeId: 0, // 服务类型ID,关联bas_service_type.id
          userType: 0, // 用户类型:0普通用户、1售前机、2工程机、3VIP用户、4经销商
          userName: '', // 用户姓名
          userMobile: '', // 来电号码
          userPhone1: '', // 其他号码1
          userPhone2: '', // 其他号码2
          userProvice: '', // 省
          userCity: '', // 市
          userCounty: '', // 县
          userTown: '', // 镇街
          areaId: 0, // 地区ID,关联bas_area.id
          userAddress: '', // 详细地址
          longitude: 0, // 经度
          latitude: 0, // 纬度
          guaranteeType: 0, // 保修类型：1保内、2保外、3未知
          brandId: 0, // 品牌ID,关联sn_company_brand.id
          buyDate: '', // 购买时间
          buyShop: '', // 购买商场
          invoiceNo: '', // 发票号
          brarcode: '', // 报单条码
          outOrderNo: '', // 外部订单号
          complaintTypeId: 0, // 客诉类型ID,关联bas_customer_complaint_type.id
          issueFaultId: 0, // 客服录单故障现象id,关联bas_fault_symptom.id
          appeals: '', // 述求
          stat: 0, // 状态：1登记;2发布;5已派网点;9已派师傅;13已出发;17已上门;20完工暂存;21已完工;22网点确认完工;23中心确认完工;24总部确认完工;91待结算;92结算驳回;93结算中止;94已结算;98挂起;99取消
          dispatchStat: '', // 工单标签
          partsStat: 0, // 配件状态：0无配件;1申请；2审核；3出库；4网点收货；8驳回；9取消；11更换；12网点返厂；13返厂确认
          recallStat: 0, // 回访状态：0未回访、1已抽样、2已回访;5用户已评价
          siteComplainStat: 0, // 申诉状态：0无申诉；3待申诉；5已申诉；7中心已审核；8中心驳回；9总部已处理；99取消
          qualityStat: 0, // 质检状态：0未质检；1质检通过；2质检不通过；
          orgId: 0, // 业务机构，关联脚手架机构表sys_dept.dept_id
          orgName: '', // 机构名称,冗余字段
          orgIdPath: '', // 机构ID路径,冗余字段.重要
          siteId: 0, // 网点ID,关联sn_user.id;
          siteName: '', // 网点名称,冗余字段
          engineerId: 0, // 工程师Id,关联sn_site_engineer.id
          engineerName: '', // 工程师名称,冗余字段
          openId: '', // 消费者报修时关联的微信号id
          sysmtomId: 0, // 故障现象id,关联bas_fault_symptom.id
          reasonId: 0, // 故障原因id,关联bas_fault_reason.id
          methodId: 0, // 维修措施id,关联bas_fix_method.id
          isMustRecall: 0, // 是否必访:0否1是
          isCallRecall: 0, // 是否可抽样:0否1是
          isUrgent: 0, // 是否急单:0否1是
          isReplaceFinish: 0, // 是否重新完工：0否1是
          urgeTimes: 0, // 催单次数
          complainTimes: 0, // 投诉次数
          managerId: 0, // 督办人,关联sys_user.id
          outTransIn: 0, // 申请保外转保内:0否1是
          settleId: 0, // 结算单ID,关联sf_batch_settle.id字段
          sendPay: '', // sendPay:打标标识，未定义
          serverTypeName: null,
          orderTypeName: null,
          symptomName: null,
          reasonName: null,
          methodName: null,

          urger: null,

          soOrderExtendDTO: {
            wishBookDate: '', // 期望上门/安装时间
            deliverTime: '', // 到货签收时间
            finishMode: 0, // 完工模式：1结算密码；2上传图片；3图片+条码；9无验证完工
            finishType: 0, // 完工方式:1总部代完工;2网点PC端完工;3网点APP完工;4师傅APP完工;5接口完工;9其他
            commentLevel: 0, // 短信满意度：1非常满意;2满意;3一般;4不满意;5非常不满意
            isSendCommentMessage: 0, // 是否已发送评价短信：0否1是
            qualityMan: '', // 质检人
            qualityDate: '', // 质检时间
            qualityRemark: '', // 质检备注
            secondSiteComplain: 0, // 是否二次申诉：0否1是
            isInstallSynchro: 0, // 是否送装同步：0否1是
            hangupType: 0, // 挂起类型：0总部挂起；1网点挂起
            hangupReason: '', // 挂起原因
            sendFlag: 0, // 外部系统传单标识:0未传;1失败;2已传
            sendMessage: '', // 外部系统传单返回信息
            sendDate: '', // 外部系统传单时间
            thirdSendFlag: 0, // 传第三方网点接口状态:0未传;1失败;2已传
            thirdSendDate: '', // 传第三方网点接口时间
            thirdSendMessage: '', // 传第三方网点接口备注,如失败时用来保存失败的原因
            tmfworderid: '', // 天猫服务市场的工单ID
            tbcustomerid: '', // 天猫服务市场的用户ID
            commercePraise: 0, // 是否电商好评：0否1是
          },
          soOrderProcessDTO: {
            orderId: 0, // 工单id，关联so_order.id
            takeOrgTime: '', // 派中心时间
            takeTime: '', // 派单时间
            acceptOperateTime: '', // 网点确认接单时间
            takeEngineerTime: '', // 派工程师时间
            engineerAcceptOperateTime: '', // 工程师确认接单时间
            firstBookOperateTime: '', // 首次预约操作时间
            firstBookDate: '', // 首次预约时间
            bookOperateTime: '', // 预约操作时间
            bookDate: '', // 预约时间
            startOffTime: '', // 出发时间
            onDoorTime: '', // 上门签到时间
            onDoorLocation: '', // 上门签到地址
            firstCompleteTime: '', // 首次完工时间
            completeTime: '', // 完工时间
            onTimeLocation: '', // 完工地址
            siteComfirmTime: '', // 网点确认完工时间
            orgComfirmTime: '', // 中心确认完工时间
            officeComfirmTime: '', // 总部确认完工时间
            recallTime: '', // 回访时间
            complaintProcessTimes: 0, // 客诉跟进次数
            complaintProcesser: '', // 客诉跟进人
            complaintProcessDate: '', // 客诉跟进时间
            siteComplaintProcessDate: '', // 网点客诉跟进时间
            applyPayDate: '', // 进入结算池时间
            payDate: '', // 提交结算时间
            cancleDate: '', // 取消/退单时间
            returnId: 0, // 取消/退单原因：关联bas_return_type.id.
            finishNote: '', // 完工备注
            comfirmNote: '', // 完工审核备注
          },
          soOrderCommentDTO: {
            orderId: 0, // 工单id，关联so_order.id
            speed: 0, // 响应速度评分
            effect: 0, // 服务效果评分
            fee: 0, // 收费评分
            other: '', // 其他评论
            pic1: '', // 图片1
            pic2: '', // 图片2
            pic3: '', // 图片3
            topLevel: 0, // 总体评价:1非常满意;2满意;3一般;4不满意;5非常不满意
            sources: 0, // 评价来源:1电商接口;2短信回复评价;3用户微信评价
          },
          soOrderSettleDTO: {
            siteFinalAmount: null,
            siteAmount: null,
            rewardAmount: null,
            mapLongDistance: null,
            longDistance: null,
            longDistanceAmount: null,
            userPayType: null,
            userPayName: null,
            userPayAccount: null,
            userPayStat: null,
            userPayNo: null,
            userPayTime: null,
            userPayStatMsg: null,
            productDate: null,
            installDate: null
          },
          soOrderSpecailFeeDTO: {
            amount: null
          },
          soOrderResultDTO: {
            inCode: null,
            outCode: null,
            finishPic1: null,
            finishPic2: null,
            finishPic3: null,
            finishPic4: null,
            finishPic5: null,
            finishPic6: null,
          },
          soOrderComplainDTOList: [],
          soOrderLineDTOList: [],
          soOrderPartsDTOList: [],
          soOrderPreconditionResultDTOList: [],
          soOrderOperationDTOList1: [],
          soOrderOperationDTOList2: [],
          soOrderOperationDTOList3: [],
          soOrderOperationDTOList4: [],
        },
        srcList: [],


        ////////////////////////////////////////////////////////////////////////////////////////////
        card: true,
        areaProps: {
          lazy: true,
          emitPath: false,
          checkStrictly: true,
          lazyLoad: this.cascaderLazyLoad
        },
        showPreconditionDialog: false,
        checkAll: false,
        checkAll2: false,
        checkedCities: ['挂壁式（5100W＜Q）变频', '挂壁式（3600W＜Q≤5100W）变频'],
        checkedCities2: ['挂壁式1变频', ],
        cities: cityOptions,
        cities2: cityOptions2,
        isIndeterminate: true,
        isIndeterminate2: true,
        // 以上卡片数据
        //  第四个页面表---服务类型
        table_area: [{
          companyId: 1,
          areaName: '空调',
          areaCode: '333',
          areaLevel: '中国广东省佛山市顺德区北滘镇',
          settleLevel: '维修投诉',
          code1: 'aaa',
          code2: 'bbbb',
          usable: 0,
        }, {
          companyId: 2,
          areaName: '冰箱',
          areaCode: '2222',
          areaLevel: '中国广东省佛山市顺德乐从镇',
          settleLevel: 0,
          code1: 'aaa222',
          code2: 'bbbb222',
          usable: 1,
        }],
        //  第五个页面表---服务类型
        table_type: [{
          typeName: '维修投诉',
          usable: '启用',
        }, {
          typeName: '安装投诉',
          usable: '禁止',
        }, {
          typeName: '售前机维修外机',
          usable: '启用',
        }],
        img_b: "",
        //认证信息-- 资质照片-测试数据

        big_img: [
          'https://bkimg.cdn.bcebos.com/pic/80cb39dbb6fd5266d0168fdb9654802bd40734fa98e2?x-bce-process=image/resize,m_lfit,w_536,limit_1'
        ],
        // showParameterDialog: false,
        showSaleConfigDialog: false,
        upload_btn: false, // 是否隐藏上传图片按钮
        upload_btn4: false, // 是否隐藏上传图片按钮
        radio: '1',
        showEdit: false,
        valuetype: 'model',
        textarea: '',
        //  value1: true,
        value2: false,
        value3: true,
        activeName: 'first',
        activeName2: 'first',
        dialog: {
          one: false,
        },
        lan: 'zh_CN',
        isEdit: false,
        tabIndex: 'first',
        dataId: '',
        tenant: {
          snCompanyOrderAttributeDTOS: [],
          url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',

          // 评分
          fen: 3.6,
          fen2: 4.5,
          fen3: 5.0,
          contractFile: [],
          longitude: '东经160度',
          latitude: "北纬60度",
          stat: 1,
          siteType: 2,
          siteFloorLevel: 1,
          siteOverAllArea: 0,
          isAutoIssue: 0,
          siteInvoiceRate: 0,
          siteAutoAccept: 0,
          checkBeyondBookdate: 0,
          autoComfirmOrder: 0,
          siteInvoiceType: 0,
          abilityPhoto: [{
            name: '用户照片',
            url: 'https://bkimg.cdn.bcebos.com/pic/7dd98d1001e93901213fb5162da043e736d12f2e38cd?x-bce-process=image/resize,m_lfit,w_536,limit_1'
          }, ],
          // 门头照片
          shopPhoto: [],
          //营业执照照片
          businessPhoto: [],
          // 基本信息-用户图片
          userPhoto: [{
            name: '用户照片',
            url: 'https://bkimg.cdn.bcebos.com/pic/80cb39dbb6fd5266d0168fdb9654802bd40734fa98e2?x-bce-process=image/resize,m_lfit,w_536,limit_1'
          }, ],
          status: 1,
          tenantAttachmentDTOs: []
        },
        showProductCategoryDialog: false,
        languageDTOs: [],
        dialogImageUrl: '',
        dialogVisible: false,
        uploadDisabled: false,
        upload_img: [

          // imageList: [], //图片数据列表,用于之后上传到后端
          // imageName: []  //图片名称
        ],

        //地址选择
        selectemp: {},
        selectedOptions: [],
        options: regionData,
        // 费用配置表

        tableData3: [{
          brandName: '预审项目1',
          tag: '家',
          usable: '必访',
        }, {
          brandName: '预审项目22',
          tag: '公司',
          usable: '申诉',
        }, {
          brandName: '预审项目333',
          tag: '公司',
          usable: '挂起',
        }, {
          brandName: '预审项目44',
          tag: '公司',
          usable: '重新完工',
        }],
      };
    },
    computed: {
      headers: function () {
        const tenantId = store.getters.userInfo.tenantId
        return {
          'Authorization': "Bearer " + store.getters.access_token,
          'TENANT-ID': tenantId ? tenantId : '1'
        };
      }
    },
    created() {
      if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
      // console.log(this.tenant,"tenant的值");
    },
    mounted() {
      // this.initTableList();
      this.getData();
      console.log(this.tenant, "tenant的值");
      console.log(this._dataId, "_dataId的值");
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event);
        console.log(tab.name, "name得值");
        if (tab.index == 0) {
          this.card = true
        } else {
          this.card = false
        }


      },

      cascaderLazyLoad(node, resolve) {
        if (!node) {
          return false
        }
        const {
          level
        } = node
        //level代表当前点击选择哪一项，，比如0代表第一次进去加载数据，1是选择省后的操作
        // if (level == 1) {
        //   this.province = node.value   //选择省后对数据进行存储，因为要用省去查询市
        // } else if (level == 2) {
        //   this.city = node.value    //同上要去查询区
        // }
        // let params = {
        //   province: this.province,
        //   city: this.city,
        // }
        console.log(node)
        this.tenant.areaId = node.value;
        console.log(this.tenant.areaId);
        this.areaName = node.pathLabels;
        console.log(node.pathLabels)
        console.log(this.areaName);
        request({
          url: '/basic/basArea/getChildrens',
          method: 'post',
          data: {
            parentId: node.value
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          const childrens = response.data.objx || {};

          const nodes = childrens.map(item => ({
            value: item.id,
            title: item.areaName,
            leaf: Number(item.hasChild) > 0
          }))
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(nodes);
        })
      },
      saveData() {
        this.$refs.editForm.validate(valid => {
          if (valid) {
            this.$baseConfirm('您确定要保存吗？').then(() => {
              this.$mask.open()

              var url = (this.isEdit ? `/admin/fwpttenant/update` : `/admin/fwpttenant/save`);
              request({
                url: url,
                method: 'post',
                data: this.tenant,
                isLoading: true,
              }).then(response => {
                this.$message({
                  message: response.data.content,
                  type: 'success',
                  duration: 500,
                  onClose: t => {
                    if (this.isEdit) {
                      this.$baseReload();
                      this.$mask.close()

                    } else {
                      this.$baseReload({
                        updateParam: {
                          _dataId: response.data.objx
                        }
                      });
                      this.$mask.close()

                    }
                  }
                });
              });
            });
          }
        });
      },
      submitUpload() {
        this.$refs.upload.submit();
      },
      handleCheckAllChange(val) {
        this.checkedCities = val ? cityOptions : [];
        this.isIndeterminate = false;
      },
      handleCheckedCitiesChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.cities.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
      },
      // 地址三级联动
      handleChange() {
        console.log(
          this.$refs["cascaderAddr"].getCheckedNodes(),
          "选择地址"
        );
        const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
        if (areaNode.value != null) {
          this.tenant.areaId = areaNode.value;
          this.areaName = areaNode.pathLabels;
        } else {
          this.tenant.areaId = null;
        }
        const panelRefs = this.$refs.cascaderAddr.$refs.panel
        if (panelRefs.activePath.length !== 0) {
          panelRefs.activePath.forEach(item => {
            if (item.children.length === 0) {
              panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
            }
          })
        }

      },
      getData() {
        if (this.dataId && !isNaN(this.dataId)) {
          this.isEdit = true;
          this.$http({
            url: api.soOrder.getDataUrl,
            method: 'post',
            data: {
              id: this.dataId
            },
            isLoading: true,
            modalStrictly: true,
          }).then(response => {
            this.formData = response.data.data
            this.srcList.push(this.formData.soOrderResultDTO.finishPic1)
            this.srcList.push(this.formData.soOrderResultDTO.finishPic2)
            this.srcList.push(this.formData.soOrderResultDTO.finishPic3)
            this.srcList.push(this.formData.soOrderResultDTO.finishPic4)
            this.srcList.push(this.formData.soOrderResultDTO.finishPic5)
            this.srcList.push(this.formData.soOrderResultDTO.finishPic6)
            this.srcList.push(this.formData.soOrderResultDTO.finishPic7)
            if (this.formData.soOrderComplainDTOList != null && this.formData.soOrderComplainDTOList.length != 0) {
              this.formData.soOrderComplainDTOList.forEach(item => {
                let list = []
                if (item.fileUrl1 != null) {
                  list.push(item.fileUrl1)
                }
                if (item.fileUrl2 != null) {
                  list.push(item.fileUrl)
                }
                if (item.fileUrl3 != null) {
                  list.push(item.fileUrl3)
                }
                item.srcList = list
              })
            }
          })
        } else {
          this.enabled = true;
        }
      },
      areaconfirm(rows) {
        if (rows.length > 0) {

          const tableData = this.table_area;
          const map = {};
          tableData.forEach(function (item) {
            map[item.preconditionId] = 1;
          });
          var items = [];
          rows.forEach((row, index) => {
            const item = {
              preconditionId: row.id,
              areaName: row.precondition
            };
            if (!map[item.preconditionId]) {
              items.push(item);
            }
          });
          this.table_area = this.table_area.concat(items);
        }
      },
      preconditionconfirm(rows) {
        if (rows.length > 0) {

          const tableData = this.table_type;
          const map = {};
          tableData.forEach(function (item) {
            map[item.preconditionId] = 1;
          });
          var items = [];
          rows.forEach((row, index) => {
            const item = {
              preconditionId: row.id,
              typeName: row.precondition
            };
            if (!map[item.preconditionId]) {
              items.push(item);
            }
          });
          this.table_type = this.table_type.concat(items);
        }
      },
      // 删除所选的数据  2表
      handleDelete1_2(index) {
        this.tenant.snCompanyOrderAttributeDTOS.splice(index, 1);
      },
      AddListRow1_2() {

        this.tenant.snCompanyOrderAttributeDTOS.push({})
      },
      // 上传成功
      handleSuccess(response, file) {
        // 上传成功后，隐藏上传按钮
        this.upload_btn = true;
        // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
        // Vue.set(this.tenant.shopPhoto, 'pic', res.data.url)

      },
      handleRemove(response, file) {
        // 上传成功后，显示上传按钮
        this.upload_btn = false;
      },

      // 上传成功
      handleSuccess4(res, file, picIndex) {
        // 上传成功后，隐藏上传按钮
        this.upload_btn4 = true;
        // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
        Vue.set(this.tenant.businessPhoto, )

      },
      handleRemove4(response, file) {
        // 上传成功后，显示上传按钮
        this.upload_btn4 = false;
      },
      handleDelete2(index) {
        this.table_area.splice(index, 1);
      },
      handleDelete(index) {
        this.table_type.splice(index, 1);
      },

      // 第一个  表格
      formatter(row, column) {
        return row.isNeedReturn == 1 ? '是' : '否'
      },
      formatter1(row, column) {
        return row.isCheck == 1 ? '是' : '否'
      },
      formatter2(row, column) {
        return row.isPast == 1 ? '是' : '否'
      },
      formatter3(row, column) {
        if (row.afterFlow == 1) {
          return "必访"
        } else if (row.afterFlow == 2) {
          return '申诉'
        } else if (row.afterFlow == 3) {
          return '挂起'
        } else if (row.afterFlow == 4) {
          return '重新完工'
        } else if (row.afterFlow == 9) {
          return '关闭'
        }

      },
      // 卡片事件
      //点击查看图片
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
        // console.log(fileList, "已上传文件")
      },
      // 上传发生变化钩子
      // 注意 :on-remove="handleimageChange"与:on-change="handleimageChange" 都绑定这个方法，这样无论是上传图片还是移除图片，都会更新图片数据列表
      handleimageChange(file, fileList) {
        this.upload_img = fileList;
        // this.upload_img.imageName=fileList.name;
        console.log(fileList, "文件状态改变时")
        console.log(file, "文件状态改变时file")
      },
    },
  };
</script>
<style lang="scss" scoped>
  #containt .detail-wrap .d-header {
    margin: -6px 0px 0 -12px !important;
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
  }

  .el-cascader-panel {
    .el-radio__inner {
      border: 0px;
      background: transparent;
    }

    .el-radio__input.is-checked .el-radio__inner {
      background: none;
    }

    .el-radio {
      height: 100%;
      width: 150px;
      position: absolute;
      z-index: 10;
    }
  }

  .header_dialog {
    border-radius: 8px !important;
    height: 800px !important;
  }

  el-dialog {
    border-radius: 8px !important;
    box-shadow: 0 0 24px rgb(0 0 0 / 22%) !important;
  }

  v::deep .el-upload .el-upload--picture-card {
    position: relative;
    left: -200px;
  }

  // 单选框
  .radio_item {
    width: 24%;
    margin-top: 10px;
    margin-bottom: 10px !important;

    >span {
      display: inline-block;
      width: 120px;
      margin-right: 13px;
      text-align: right;
      font-weight: 400;
      color: rgba(86, 86, 86, 0.96);
      font-size: 12px;
    }
  }

  .firm {
    .el-input {
      width: 150px;
    }
  }

  .type_title {
    font-weight: 400;
    text-align: right;
    width: 112px;
    position: relative;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }

  .type_select {
    width: 120px;
    text-align: center;
  }

  .type_brand {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;

    >div {
      margin: 16px 0;
      width: 25%;
    }
  }

  // 备注的样式
  .annotate {
    padding: 0px !important;
    height: 28px !important;
    min-height: 28px !important;
  }

  .el-textarea__inner {
    padding: 0px !important;
    height: 28px !important;
    min-height: 28px !important;
  }

  // 装图片的  大框
  ::v-deep.table-detail .el-upload--picture-card {
    // margin-top: 10px;
    width: 40px;
    height: 40px;
    line-height: 50px !important;
  }

  ::v-deep .el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 40px;
    height: 40px;
    margin-right: 14px;
    border-radius: 2px;
    padding: 0 !important;
    border-color: #e8e8e8;
    margin-top: 0;
    margin-bottom: 10px;
  }

  ::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
    width: 40px;
    height: 40px;
    padding: 0 !important;
    position: inherit;
    cursor: pointer;
  }

  ::v-deep.el-upload-list__item.is-success .el-upload-list__item-status-label {
    display: none !important;
  }

  // witch 开关  标题的宽度
  .el-switch__label * {
    line-height: 1;
    width: 160px !important;
    display: inline-block;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }

  // 清楚表格 默认padding
  .el-table--medium .el-table__cell {
    padding: 0px 0 !important;
  }

  .table_item {
    .el-table__row:hover>td {
      background-color: #D4E7FF !important;
    }
  }

  .pic_item {

    .el-upload--picture-card {
      margin-top: 1px;
      width: 36px !important;
      height: 36px !important;
      line-height: 46px !important;
    }
  }

  // 卡片样式
  .card_item {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;


    .el-card__header {
      padding: 10px 20px 5px;
      border-bottom: 1px dashed #7a7e7c;
      font-weight: 600;
      font-size: 13px;
    }

    .el-card__body,
    .el-main {
      padding: 10px 20px;
    }

    .text {
      font-size: 12px;
    }

    .item {
      margin-bottom: 12px;
      display: block;
    }

    .clearfix:before,
    .clearfix:after {
      display: table;
      content: "";
    }

    .clearfix:after {
      clear: both
    }

    .box-card {
      width: 30%;
      margin-right: 30px;
      margin-bottom: 30px;
      border: 1px solid #ccc !important;
    }
  }

  .papers {
    margin-left: 30px;
    position: absolute;

    ::v-deep.el-upload-list .el-upload-list__item {
      display: inline-block;
      width: 147px !important;
      margin-right: 14px;
      border-radius: 2px;
      border-color: #e8e8e8;
      margin-top: 7px;
      margin-left: 15px;
      padding: 0px !important;
      background-color: #e1e1e1;
      height: 20px;
    }

  }

  .btn_zdy {
    margin: 10px 0;
    border: 1px solid #dcdfe6 !important;
    border-color: #dcdfe6 !important;
    color: #606266 !important;
    font-weight: 400;
    text-align: center;
    background-color: #FBFBFB !important;
  }

  .btn_zdy:hover {
    color: #00c4b3 !important;
    border: 1px solid #00c4b3 !important;
  }

  .btn_zdy2 {
    // 选取文件合同按钮
    // margin: 10px 60px;
    margin-top: 6px;
    border: 1px solid #dcdfe6 !important;
    border-color: #dcdfe6 !important;
    color: #606266 !important;
    font-weight: 400;
    text-align: center;
    background-color: #FBFBFB !important;
  }

  .btn_zdy2:hover {
    color: #00c4b3 !important;
    border: 1px solid #00c4b3 !important;
  }

  ::v-deep .el-tabs__header {
    padding: 0;
    position: relative;
    margin: 0 0 0 0px !important;
  }

  // 步骤条
  ::v-deep .el-card__body,
  .el-main {
    padding: 0px !important;
    font-size: 12px;
  }

  .task {
    color: #62f382;
  }

  .card {
    padding: 0px 5px;
    background-color: #efefef;
  }

  .title_icon1 {
    display: inline-block;
    background: rgba(42, 100, 148, 0.16);
    width: 19px;
    background-color: #409EFF;
    color: #fff;
    text-align: center;
    margin-bottom: 15px;
  }

  .title_icon {
    display: inline-block;
    background: rgba(42, 100, 148, 0.16);
    width: 19px;
    background-color: #00c4b3;
    color: #fff;
    text-align: center;
    margin-bottom: 15px;
  }

  ::v-deep .el-timeline-item__node {
    background-color: #ffffff !important;
    border: 1px solid #0550ef;
  }

  .bread {
    span {
      color: rgba(86, 86, 86, 0.96) !important;
    }

    ::v-deep .el-collapse-item__content {
      padding-bottom: 0px;
      background-color: #efefef;

    }
  }

  .el-timeline {
    margin-top: 40px;
    margin: 0;
    list-style: none;
    margin-left: 6px;
    border: 1px solid #fbfbfb;
    padding-top: 12px;
    height: 72.5vh;
    overflow-y: scroll;
    background-color: #f2f2f2;
    padding-left: 10px !important;
  }

  .card_bread {
    position: relative !important;
  }

  ::v-deep .el-tabs__content {
    overflow: visible !important;

  }

  #containt .detail-wrap .d-cont {
    overflow: unset !important;
  }

  // .el-timeline-item {
  //   position: relative;
  //   padding-bottom: 0px !important;
  //   margin-left: 47px;
  // }
  .el-timeline-item[data-v-2cf56cc1] {
    position: relative;
    margin-left: 5px;
    padding-bottom: 0px !important;
  }

  // 滚动条样式

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 5px;
    height: 12px;
  }

  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    border-radius: 0px;
    // background: rgba(224, 7, 7, 0.05);
  }

  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 00px;
    background: #cfcece;
  }

  // 步骤条 圆的位置
  ::v-deep .el-timeline-item__node--normal {
    left: 0px !important;
    width: 12px;
    height: 12px;
  }

  .el-timeline[data-v-2cf56cc1] {
    position: relative !important;
  }

  #containt .detail-wrap .d-cont .d-item {
    border: solid 1px #e9e9e9;
    padding: 0 12px 6px;
    position: relative !important;
  }

  ::v-deep .el-collapse-item__arrow {
    position: absolute !important;
    top: 12px !important;
    right: 0 !important;
    font-size: 18px;
    color: #00c4b3 !important;
  }

  .btn_zdy {
    border: 1px solid #dcdfe6 !important;
    border-color: #dcdfe6 !important;
    color: #606266 !important;
    font-weight: 400;
    text-align: center;
    background-color: #FBFBFB !important;
  }

  .btn_zdy:hover {
    color: #00c4b3 !important;
    border: 1px solid #00c4b3 !important;
  }


  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px !important;
  }


  // 本单费用位置
  .expense {
    position: absolute;
    right: 20%;
    margin-top: 5px;
    color: #00c4b3;
    font-size: 13px;
  }

  ::v-deep .el-image__preview {
    width: 60px !important;
    height: 60px !important;
  }

  .pic_main {
    display: flex;
    margin-left: 75px;
    margin-top: 10px;

    .pic_item {
      display: flex;
      margin-right: 40px;

      span {
        line-height: 60px;
        font-size: 12px;
        color: rgba(86, 86, 86, 0.96);
        font-weight: 400;

      }
    }
  }

  // 步骤条
  .el-steps--simple {
    margin: 20px 0 6px;
  }

  .el-step.is-simple {
    width: 225px;
  }

  .audit {
    span {
      font-size: 12px;
      color: rgba(86, 86, 86, 0.96);
      font-weight: 400;
    }
  }

  // 卡片样式
  .card_item {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;


    .el-card__header {
      padding: 10px 20px 5px;
      border-bottom: 1px dashed #7a7e7c;
      font-weight: 600;
      font-size: 13px;
    }

    .el-card__body,
    .el-main {
      padding: 10px 20px;
    }

    .text {
      font-size: 12px;
    }

    .item {
      margin-bottom: 12px;
      display: block;
    }

    .clearfix:before,
    .clearfix:after {
      display: table;
      content: "";
    }

    .clearfix:after {
      clear: both
    }

    .box-card {
      width: 30%;
      margin-right: 30px;
      margin-bottom: 30px;
      border: 1px solid #ccc !important;
    }
  }

  // 折叠样式对其
  // .table-detail {
  //   tr{
  //     display:block;
  //   }
  // }
  #containt .table-detail tbody tr th {
    display: table-cell;
    vertical-align: middle;
  }

  #containt .table-detail tbody tr td {

    display: table-cell;
    vertical-align: middle;
  }

  .title_time {
    margin-top: -13px;
    font-size: 12px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .span1 {
      color: #00c4b3 !important;
      width: 35%;
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .span2 {
      margin-right: 20px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

  }


  // 字段之间的距离
  #containt .table-detail tbody tr td {
    padding: 5px 12px;
    width: 172.2px;
    height: 27.2px !important;
    word-break: break-word;
  }

  .information {
    padding: 4px 10px;
    background-color: #E1F2FF;
    color: #268AEA;
    border-radius: 3px;
    margin: 0 5px;
  }

  #containt .table-detail tbody tr th {
    width: 7vw !important;
  }

  #containt .table-detail tbody tr td {
    width: 10vw !important;
    padding: 0 0 0 7px !important;
    ;
  }

  ::v-deep .el-step__title {
    font-size: 11px;
    line-height: 25px;
  }

  #containt .detail-wrap .d-cont .d-item {
    padding: 5px 0 !important;
  }

  .gather .el-tab-pane {
    margin-top: 10px;
    padding: 20px 0;

    >>>.el-tabs__active-bar {
      left: 20px !important;
    }

    .el-tabs__nav {
      margin-left: 20px !important;
    }
  }

  #containt .title b {
    margin-left: 0px !important;
  }
  ::v-deep .product  th:after{
    display:none !important;
  }
  ::v-deep .product td{
    padding:5px 0!important;

  }
  ::v-deep .vxe-table--render-default .vxe-cell {
    text-align: left!important;}
  .el-image {
  border: dashed 1px #e2e2e2;
  margin-right: 20px;
}
.undergo{
  ::v-deep .el-card.is-always-shadow {
    background-color: #f2f2f2;
    position: relative;
}
.el-timeline {
    background-color: #fff;
    padding-left: 10px !important;
    height: 100% !important;
}
.el-image {
    width: 60px !important;
    height: 60px !important;
}

}
</style>
